export default "__VITE_ASSET__Bf5Bo5$3__"